import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import { checkPiAnswer, pick, range, renderPiAnswer, renderPiUserAnswer, SolidPiInput } from "../commonSolidPi";

export function generateTask() {
  const r = pick(range(2, 10));
  const k = 4 * r * r;
  return { type: "SphereSurfaceAreaTask", data: { r, k, numeric: k * Math.PI } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Oblicz pole powierzchni kuli o promieniu <InlineMath math={`${data.r}`} />.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return <SolidPiInput value={userAnswer} onChange={onChange} disabled={disabled} label="P" />;
}

export function checkAnswer({ data }, userAnswer) {
  return checkPiAnswer(data.numeric, userAnswer);
}

export function renderAnswer({ data }) {
  return renderPiAnswer("P", data.k);
}

export function renderUserAnswer(userAnswer) {
  return renderPiUserAnswer(userAnswer, "P");
}

export function renderExplanation({ data }) {
  const { r, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Korzystamy ze wzoru na pole powierzchni kuli.</p>
      <BlockMath math={`P=4\\pi r^2`} />
      <p><strong>Krok 2.</strong> Podstawiamy promień.</p>
      <BlockMath math={`P=4\\pi\\cdot ${r}^2=${k}\\pi`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`P=${k}\\pi`} />.</p>
    </div>
  );
}
